<template>
  <div>
    <div class="fast-register hidden-xs-only flex-align-center flex-center">
      <div class="fast-box flex-align-center ">
        <div class="gift-img hidden-sm-and-down">
          <img src="../../assets/image/gift.png" alt="">
        </div>
        <div class="gift-shu mr20 ml20 hidden-sm-and-down"></div>
        <div class="gift-box">
          <p class="gift-active mb10">新用户注册即送 60 元代金券</p>
          <p>超多优惠券，无门槛使用，免费体验顶级云渲染服务</p>
        </div>
      </div>
      <div class="register-box">
        <div class="register-input flex">
          <el-input placeholder="请输入手机号"  
          type="text" 
          v-model.number="phone" 
          maxlength="11"
          oninput="value=value.replace(/[^\d]/g,'')" 
          class="input-with-select"
          @keyup.enter.native="registerClick"
          clearable>
            <el-button class="input-append" 
            slot="append" 
            type="success"  
            @click="registerClick"
            >立即注册</el-button>
          </el-input>
        </div>
      </div>
    </div>
    <div class="fast-register hidden-sm-and-up">
      <div class="fast-box flex-center">
        <div class="gift-box">
          <p class="gift-active mb10">新用户注册即送 60 元代金券</p>
          <p>超多优惠券，无门槛使用，免费体验顶级云渲染服务</p>
        </div>
      </div>
      <div class="register-box mt10">
        <div class="register-input flex-center">
          <el-input placeholder="请输入手机号"  
          type="text" 
          v-model.number="phone" 
          maxlength="11"
          oninput="value=value.replace(/[^\d]/g,'')" 
          class="input-with-select"
          @keyup.enter.native="registerClick"
          clearable>
            <el-button class="input-append" 
            slot="append" 
            type="success"  
            @click="registerClick"
            >立即注册</el-button>
          </el-input>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      phone: null
    }
  },
  methods: {
    // 立即注册
    registerClick () {
      if (this.phone) {
        window.location.href = 'https://v.renderg.com/#/register?flag=register&phone='+this.phone
      } else {
        window.location.href = 'https://v.renderg.com/#/register?flag=register'
      }
    }
  },
}
</script>